import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";
import { CODE_FONT_SIZES } from "@/components/tiptap/code-block/codeFontSize";
import { useStore } from "@/store/RootStoreProvider";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
};

export const CodeFontSizeSwitcher = observer(function CodeFontSizeSwitcher({ doc }: Props) {
  const t = useTranslations("sidebar.blocks");
  const { userSettings } = useStore();
  const {
    editor: { tiptap },
  } = doc;
  if (!tiptap) {
    return null;
  }

  const currentSize = userSettings.codeFontSize;

  const items = CODE_FONT_SIZES.map((size) => ({
    title: String(size),
    active: currentSize === size,
    onClick: () => {
      userSettings.setCodeFontSize(size);
    },
  }));

  return (
    <Dropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton
          as="div"
          title={String(currentSize)}
          tooltipTitle={t("code.fontSize")}
        />
      }
      items={items}
      itemsClassName="min-w-[150px]"
    />
  );
});
